import { createContext, useContext, useMemo } from 'react';
import AutosaveAlertsContainer from '../components/AutosaveAlertsContainer';
import AutosaveIndicator from '../components/AutosaveIndicator';
import UnsavedChangesAlert from '../components/UnsavedChangesAlert';
import { useAutosaveCore } from '../hooks/useAutosaveCore';
import { useAutosaveEditingState } from '../hooks/useAutosaveEditingState';
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const AutosaveContext = /*#__PURE__*/createContext(undefined);
export const AutosaveProvider = ({
  children
}) => {
  const parentContext = useContext(AutosaveContext);
  const {
    getIsEditing,
    setIsEditing
  } = useAutosaveEditingState();
  const {
    cancelRequestsForSource,
    enqueueRequest,
    handleUndo,
    hasRequestForSource,
    lastSavedPacket,
    saveValidRequests,
    registerHandler,
    requests,
    status
  } = useAutosaveCore();
  const value = useMemo(() => {
    return {
      getIsEditing,
      setIsEditing,
      cancelRequestsForSource,
      enqueueRequest,
      hasRequestForSource,
      registerHandler,
      saveValidRequests
    };
  }, [cancelRequestsForSource, enqueueRequest, getIsEditing, hasRequestForSource, registerHandler, saveValidRequests, setIsEditing]);
  if (parentContext !== undefined) {
    return /*#__PURE__*/_jsx(_Fragment, {
      children: children
    });
  }
  return /*#__PURE__*/_jsxs(AutosaveContext.Provider, {
    value: value,
    children: [/*#__PURE__*/_jsxs(AutosaveAlertsContainer, {
      children: [/*#__PURE__*/_jsx(UnsavedChangesAlert, {
        requests: requests
      }), /*#__PURE__*/_jsx(AutosaveIndicator, {
        status: status,
        onUndo: handleUndo,
        packet: lastSavedPacket
      })]
    }), children]
  });
};
export const useAutosaveContext = () => {
  const context = useContext(AutosaveContext);
  if (context === undefined) {
    throw new Error('useAutosaveContext must be used within AutosaveProvider');
  }
  return context;
};